// CSS
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/css/main.scss";
import "font-awesome/css/font-awesome.min.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-datepicker/dist/react-datepicker.css";
// OTHERS
import { useEffect } from "react";
import Layout from "./layout/Layout";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import { fetchAuthUser } from "./redux/slices/UserSlice";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./Firebase/firebaseConfig";
import { fetchSystemConfiguration } from "./redux/slices/CommonSlice";


function removeExpiredToken() {
  const token = localStorage.getItem("token");
  if (!token) return;

  const jwtPayload = JSON.parse(atob(token.split(".")[1]));

  const expirationTime = jwtPayload.exp * 1000;

  if (Date.now() > expirationTime) {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("userId");
    localStorage.removeItem("userType");
    window.location.reload();
  }
}

function App() {
  // const { i18n, t } = useTranslation("global");
  const dispatch = useDispatch();

  const lang = localStorage.getItem("language");

  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    if ('serviceWorker' in navigator && "PushManager" in window) {
      navigator.serviceWorker
        .register('./firebase-messaging-sw.js')
        .then((registration) => {
          // console.log('Service Worker registered:', registration);
          Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
              console.log('Notification permission granted.');

              getToken(messaging, {
                vapidKey: process.env.REACT_APP_VAPID_KEY,
                serviceWorkerRegistration: registration,
              })
                .then((currentToken) => {
                  if (currentToken) {
                    // console.log('FCM Token:', currentToken);
                    localStorage.setItem("firebaseToken", currentToken)

                  } else {
                    console.warn('No registration token available.');
                  }
                })
                .catch((err) => {
                  console.error('An error occurred while retrieving token. ', err);
                });
            } else {
              console.warn('Notification permission denied.');
            }
          });
        })
        .catch((err) => {
          console.error('Service Worker registration failed:', err);
        });
    }

    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
    });
  }, [])

  useEffect(() => {
    if (token) {
      dispatch(fetchAuthUser())
    }
  }, [JSON.stringify(token), navigate]);

  // useEffect(() => {
  //   removeExpiredToken();
  // }, []);

  useEffect(() => {
    if (!lang) {
      localStorage.setItem("language", "en");
    }
  }, []);

   useEffect(() => {
    dispatch(fetchSystemConfiguration());
  }, [dispatch]);

  useEffect(() => {
    let htmlEl = document.querySelector("html");
    lang == "ar"
      ? htmlEl.setAttribute("dir", "rtl")
      : htmlEl.setAttribute("dir", "ltr");
    lang == "ar"
      ? htmlEl.setAttribute("lang", "ar")
      : htmlEl.setAttribute("lang", "en");
  }, []);

  return (
    <>
      <div className="App">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        <Layout>
          <AppRoutes />
        </Layout>
      </div>
    </>
  );
}

export default App;

// const Optimistic = () => {
//   const [messages, setMessages] = useState([
//     { text: "Hey, I am initial!", sending: false, key: 1 },
//   ]);
//   const [optimisticMessages, addOptimisticMessage] = useOptimistic(
//     messages,
//     (state, newMessage) => [
//       ...state,
//       {
//         text: newMessage,
//         sending: true,
//       },
//     ]
//   );

//   async function sendFormData(formData) {
//     const sentMessage = await fakeDelayAction(formData.get("username"));
//     setMessages((messages) => [...messages, { text: sentMessage }]);
//   }

//   async function fakeDelayAction(message) {
//     await new Promise((res) => setTimeout(res, 1000));
//     return message;
//   }

//   const submitData = async (userData) => {
//     addOptimisticMessage(userData.get("username"));

//     await sendFormData(userData);
//   };

//   return (
//     <>
//       {optimisticMessages.map((message, index) => (
//         <div key={index}>
//           {message.text}
//           {!!message.sending && <small> (Sending...)</small>}
//         </div>
//       ))}
//       <form action={submitData}>
//         <h1>OptimisticState Hook</h1>
//         <div>
//           <label>Username</label>
//           <input type="text" name="username" />
//         </div>
//         <button type="submit">Submit</button>
//       </form>
//     </>
//   );
// };

// export default Optimistic;

// const FormState = () => {
//   const submitForm = (prevState, queryData) => {
//     const name = queryData.get("username");
//     console.log(prevState); // previous form state
//     if (name === "john") {
//       return {
//         success: true,
//         text: "Welcome",
//       };
//     } else {
//       return {
//         success: false,
//         text: "Error",
//       };
//     }
//   };
//   const [message, formAction] = useFormState(submitForm, null);
//   return (
//     <form action={formAction}>
//       <label>Name</label>
//       <input type="text" name="username" />
//       <button>Submit</button>
//       {message && <h1>{message.text}</h1>}
//     </form>
//   );
// };
